import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 0.25; transform: scale(0.8); }
  50% { opacity: 1; transform: scale(1); }
`;

const Dots = styled.span`
  display: inline-flex;
  gap: 0.45rem;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;

  & > span {
    width: 0.55rem;
    height: 0.55rem;
    border-radius: 50%;
    background-color: ${props => props.theme.colors.primary};
    animation: ${pulse} calc(1.1s * var(--motion-duration-scale, 1)) ease-in-out infinite;
  }

  & > span:nth-child(2) {
    animation-delay: 0.18s;
  }

  & > span:nth-child(3) {
    animation-delay: 0.36s;
  }

`;

// Small dot-matrix loading indicator. Reuses the existing "loading" string
// for its screen-reader announcement so no new i18n keys are needed.
const DotLoader = () => {
  const { t } = useTranslation();
  return (
    <Dots role="status" aria-label={t('projects_section.loading')}>
      <span aria-hidden="true" />
      <span aria-hidden="true" />
      <span aria-hidden="true" />
      <span className="visually-hidden">{t('projects_section.loading')}</span>
    </Dots>
  );
};

export default DotLoader;
